<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <div
      class="flex-x-center solid-bottom padding-bottom-xs margin-bottom"
      style="height: 4em"
    >
      <div class="text-bold text-olive text-xl flex-x-center flex-sub">
        <span v-if="storage_order_type == 0">新增发货单</span>
        <span v-if="storage_order_type == 1">修改发货单</span>
      </div>
      <div class="">
        <el-button size="small" @click="orderClick" class="bg-olive"
          >选择入库数据</el-button
        >
        <el-button size="small" class="bg-olive" @click="saveData">保存</el-button>
        <el-button size="small" class="margin-right-xs" @click="backHome"
          >返回首页</el-button
        >
      </div>
    </div>
    <hr />
    <!-- 操作栏 -->
    <div style="margin-bottom: 10px">
      <el-descriptions
        direction="horizontal"
        :column="3"
        border
        :label-style="labelStyle"
      >
        <el-descriptions-item contentStyle="width: 300px">
          <template slot="label">供应商名称</template>
          <span>{{ addData.baseSupplierName }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 300px">
          <template slot="label">供应商编号</template>
          <span>{{ addData.baseSupplierNumber }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width:300px">
          <template slot="label">发货日期</template>
          <el-date-picker
            style="width: 100%"
            v-model="addData.baseEntranceHomeTime"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="发货日期"
          >
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 300px">
          <template slot="label">标题</template>
          <el-input v-model="addData.docName" placeholder="标题" class="input"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 300px">
          <template slot="label">全局搜索码</template>
          <el-input
            v-model="addData.globalSearchNumber"
            placeholder="全局搜索码"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">超量入库模式</template>
          <el-select
            v-model="addData.excessiveInventoryMode"
            placeholder="请选择超量入库模式"
            style="width: 100%"
          >
            <el-option :value="0" label="正常对账"></el-option>
            <el-option :value="1" label="作为赠品"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 内容 -->
    <div>
      <myTable
        :overflow="true"
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        :list="itemList"
        :titleList="titleList"
        :tableBtnList="itemTableBtnList"
        @cellClickEvent="cellClickEvent"
        @btnClick="productBtnClick"
        @inputNumberClick="inputNumberClick"
        @resizableChange="resizableChange"
        @excelOpen="excelOpen"
        @excelSuccess="excelSuccess"
        ref="myTableOne"
      ></myTable>
    </div>

    <!-- 产品选择 -->
    <el-dialog
      :visible.sync="dialogState.show2"
      :close-on-click-modal="false"
      class="dialog"
      append-to-body
      title="选择产品"
      width="80%"
      @close="dialogClose"
    >
      <el-input
        v-model="searchValue"
        style="width: 400px; margin: 0 10px 10px 0"
        size="small"
      ></el-input>
      <el-button size="small" @click="getpurchaseUnreceiptOrderlist(searchValue)"
        >搜索</el-button
      >
      <myTable
        :height="500"
        v-loading="listLoading"
        :overflow="true"
        :id="'myTableThree'"
        :columnType="'columnBox'"
        :list="ordertList"
        :titleList="orderTitleList"
        @selectAllCheckboxChange="selectAllCheckboxChange"
        @selectChangeEvent="selectChangeEvent"
        ref="myTableThree"
      ></myTable>
      <!-- 分页组件 -->
      <pagination
        :total="ordertListQuery.total"
        :page.sync="ordertListQuery.pageNum"
        :limit.sync="ordertListQuery.pageSize"
        :page-sizes="[10, 20, 50, 100, 300]"
        style="text-align: right; float: right; margin-bottom: 30px"
        @pagination="orderClick"
      />
      <div style="clear: both"></div>
      <div style="text-align: right">
        <el-button @click="showClick()" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  subFloat,
  mulFloat,
  accAdd,
  year,
  month,
  day,
  _debounce,
  getCurrentTime,
  selcetSetting,
  updateSetting,
  customMenu,
} from "@/utils/myUtils";
import {
  pmgtPurchasesReceiptDocDetail_selectCooperativeSupplierPurchaseUnReceiptOrderList,
  pmgtPurchasesReceiptDoc_add,
} from "@/api/myController/purchase";
export default {
  props: {
    storage_order_type: {
      type: Number,
      default: 0,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    homeIndex: {
      type: Number,
      default: false,
    },
    modelType: {
      type: Number,
      default: 0,
    },
    addData: {
      type: Object,
      default: () => ({
        purchasesReceiptDocId: 0,
        purchasesReceiptDocNumber: "",
        baseWarehouseWareId: 0,
        baseWarehouseWareName: "",
        baseSupplierName: "",
        baseSupplierNumber: "",
        baseSupplierId: 0,
        baseEntranceHomeTime: "",
        docName: "",
        globalSearchNumber: "",
      }),
    },
  },
  components: {},
  data() {
    return {
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        "min-width": "100px",
        "word-break": "keep-all",
      },
      //* *************订单需要的数据 */
      ordertList: [],
      // 按钮集合
      ordertListQuery: {
        baseSupplierId: 0,
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      orderTitleList: [
        {
          id: 0,
          name: "采购编号", // 必传
          value: "purchaseOrderNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          color: "#409eff",
          width: 115,
        },
        {
          id: 0,
          name: "全局搜索码", // 必传
          value: "globalSearchNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          color: "#409eff",
          width: 115,
        },
        {
          id: 1,
          name: "供应商名称",
          value: "baseSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          color: "#409eff",
          width: 180,
        },
        {
          id: 2,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 3,
          name: "规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 240,
        },
        {
          id: 4,
          name: "采购日期",
          value: "basePurchaserOrderTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 160,
        },
        {
          id: 5,
          name: "采购数量",
          value: "baseAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          canEdit: false,
          width: 115,
        },
        // {
        //   id: 60,
        //   name: "冻结数量",
        //   value: "valueUnreceiptLockAmount",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "numberAccuracy",
        //   canEdit: false,
        //   width: 115,
        // },
        {
          id: 61,
          name: "可入库数量",
          value: "unValueUnreceiptLockAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 7,
          name: "含税单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 8,
          name: "未税单价",
          value: "baseMaterialUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 9,
          name: "税率(%)",
          value: "baseTaxRate",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 115,
        },
        {
          id: 10,
          name: "含税总价",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 11,
          name: "未税总价",
          value: "baseMaterialTotalpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 12,
          name: "采购人",
          value: "basePurchaserName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 115,
        },
        {
          id: 13,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 160,
        },
      ],
      itemListPro: [],
      searchValue: "",
      //* ****************** */
      listLoading: true,
      itemTableBtnList: ["删除"],
      titleList: [
        {
          id: 1,
          name: "产品图片", // 必传
          value: "baseImgUrl", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "imageListAll", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 80,
        },
        {
          id: 0,
          name: "产品图纸",
          value: "baseDrawingFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: "产品附件",
          value: "baseFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: "订单图片",
          value: "valueImgList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: "订单附件",
          value: "valueFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: "采购编号", // 必传
          value: "purchaseOrderNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          width: 115,
        },
        {
          id: 1,
          name: "供应商名称",
          value: "baseSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 2,
          name: "产品编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 160,
        },
        {
          id: 2,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 4,
          name: "单位",
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 60,
        },
        {
          id: 3,
          name: "产品规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 240,
        },
        {
          id: 4,
          name: "交期",
          value: "baseReceiptDate",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 160,
        },
        {
          id: 5,
          name: "采购数量",
          value: "baseAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 61,
          name: "可发货数量",
          value: "unValueUnreceiptLockAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 62,
          name: "本次发货数量",
          value: "baseEntranceHomeAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          alwaysEditState: true,
          canEdit: true,
          width: 115,
        },
        {
          id: 7,
          name: "含税单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 8,
          name: "未税单价",
          value: "baseMaterialUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 9,
          name: "税率(%)",
          value: "baseTaxRate",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 115,
        },
        {
          id: 10,
          name: "含税总价",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 11,
          name: "未税总价",
          value: "baseMaterialTotalpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 12,
          name: "采购人",
          value: "basePurchaserName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 115,
        },
      ],
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
      },
    };
  },
  created() {
    // 处理收货
    if (this.routeType && this.routeType == 1) {
      this.orderHandle(this.routeQuery);
    }
    if (this.storage_order_type == 0) {
      this.getList();
    }
  },
  methods: {
    //
    getList() {
      this.addData.docName = "发货";
      this.addData.baseSupplierId = this.getUserInfo.supplierId;
      this.addData.baseSupplierName = this.getUserInfo.showName;
      this.addData.baseSupplierNumber = this.getUserInfo.supplierNumber;
    },
    orderHandle(row) {
      this.addData.baseWarehouseWareName = row.valueWarehousingWarehouse;
      this.addData.baseWarehouseWareId = row.warehouseId;
      this.addData.globalSearchNumber = row.globalSearchNumber;
      this.addData.baseSupplierId = row.baseSupplierId;
      this.addData.baseSupplierName = row.baseSupplierName;
      this.addData.baseSupplierNumber = row.baseSupplierNumber;
      this.addData.docName = "发货-" + row.docName;
      this.itemList = [];
      pmgtPurchasesReceiptDocDetail_selectCooperativeSupplierPurchaseUnReceiptOrderList({
        filter: {
          purchasesOrderDocId: row.purchasesOrderDocId,
        },
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            item.fromDocAndDetailId =
              row.purchasesOrderDocId + "," + item.purchasesOrderDocDetailId;
            item.unValueUnreceiptLockAmount = subFloat(
              item.baseAmount,
              item.valueUnreceiptLockAmount
            );
            item.baseEntranceHomeAmount = item.unValueUnreceiptLockAmount;
            item.baseMaterialTotalprice = mulFloat(
              item.baseMaterialUnitprice,
              item.baseEntranceHomeAmount
            );
            item.baseMaterialTotalpriceUntaxed = mulFloat(
              item.baseMaterialUnitpriceUntaxed,
              item.baseEntranceHomeAmount
            );
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
          });
          this.itemList = res.data.data.dataList;
        }
        this.listLoading = false;
      });
    },
    // 动态计算
    inputNumberClick(row, val) {
      switch (val) {
        case "baseEntranceHomeAmount":
          row.baseMaterialTotalprice = mulFloat(
            row.baseMaterialUnitprice,
            row.baseEntranceHomeAmount
          );
          row.baseMaterialTotalpriceUntaxed = mulFloat(
            row.baseMaterialUnitpriceUntaxed,
            row.baseEntranceHomeAmount
          );
          break;
        default:
          break;
      }
    },
    productBtnClick(row, item, index, state) {
      switch (item) {
        case "删除":
          this.itemList.splice(index - 1, 1);
          break;
        default:
          break;
      }
    },
    async saveData() {
      //   await this.$judgeNumber(
      //     this.addData.purchasesReceiptDocNumber,
      //     this.addData.purchasesReceiptDocId
      //   );
      let orderDetails = [];
      this.itemList.forEach((item) => {
        if (item.baseMetaMaterialId > 0 || item.baseMetaMaterialId) {
          orderDetails.push(item);
        }
      });
      if (orderDetails.length <= 0) {
        this.$message.error("发货数据不可为空！");
        throw Error("发货数据不可为空！");
      }
      let costomState = true;
      orderDetails.forEach((item) => {
        if (!item.baseEntranceHomeAmount || item.baseEntranceHomeAmount <= 0) {
          costomState = false;
        }
      });
      if (costomState == false) {
        this.$message.error("数量不可为空！");
        throw Error("数量不可为空！");
      }
      let costomStateTwo = true;
      orderDetails.forEach((item) => {
        if (item.baseEntranceHomeAmount > parseFloat(item.unValueUnreceiptLockAmount)) {
          // costomStateTwo = false;
        }
      });
      if (costomStateTwo == false) {
        this.$message.error("本次发货数量过大！");
        throw Error("本次发货数量过大！");
      }
      let baseSumMaterialAcountTotal = 0;
      let baseSumMaterialPriceTotal = 0;
      let baseSumMaterialUntaxedPriceTotal = 0;
      // 处理数据
      orderDetails.forEach((item) => {
        item.valueUnreceiptAmount = item.baseEntranceHomeAmount;
        item.valueStatementAmount = item.baseMaterialTotalprice;
        item.valueUnpaidAmount = item.baseMaterialTotalprice;
        item.valueReceiptAmount = 0;
        item.baseCurrency = "人民币";
        baseSumMaterialAcountTotal = accAdd(
          baseSumMaterialAcountTotal,
          item.baseEntranceHomeAmount
        );
        baseSumMaterialPriceTotal = accAdd(
          baseSumMaterialPriceTotal,
          item.baseMaterialTotalprice
        );
        baseSumMaterialUntaxedPriceTotal = accAdd(
          baseSumMaterialUntaxedPriceTotal,
          item.baseMaterialTotalpriceUntaxed
        );
      });
      let json = {
        pmgtPurchasesReceiptDocDto: {
          valueUnreconciledLockAmount: 0,
          excessiveInventoryMode: this.addData.excessiveInventoryMode,
          purchasesReceiptDocId: this.addData.purchasesReceiptDocId,
          baseEntranceHomeTime: this.addData.baseEntranceHomeTime,
          baseSupplierName: this.addData.baseSupplierName,
          baseSupplierId: this.addData.baseSupplierId,
          baseWarehouseWareId: this.addData.baseWarehouseWareId,
          baseWarehouseWareName: this.addData.baseWarehouseWareName,
          purchasesReceiptDocNumber: this.addData.purchasesReceiptDocNumber,
          baseSumMaterialAcountTotal,
          baseSumMaterialPriceTotal,
          baseSumMaterialUntaxedPriceTotal,
          statusCheck: 0,
          statusDoc: 0,
          docName: this.addData.docName,
          globalSearchNumber: this.addData.globalSearchNumber,
        },
        pmgtPurchasesReceiptDocDetailDtoList: orderDetails,
      };
      await pmgtPurchasesReceiptDoc_add(json).then((res) => {
        this.$message.success("保存成功！");
        let json = {
          purchasesReceiptDocId: res.data.data,
        };
        this.$emit("backHome", 16, json);
      });
    },

    orderClick() {
      if (this.addData.baseSupplierId == "") {
        this.$message.error("未选择供应商");
        return;
      }
      this.dialogState.show2 = true;
      this.searchValue = "";
      this.listLoading = true;
      this.getpurchaseUnreceiptOrderlist();
    },
    getpurchaseUnreceiptOrderlist(val) {
      var filter = {};
      if (val) {
        (filter = {}), (filter.searchString = val);
      }
      pmgtPurchasesReceiptDocDetail_selectCooperativeSupplierPurchaseUnReceiptOrderList({
        pmgtPurchasesOrderDocDtoFilter: this.ordertListQuery,
        filter,
        pageParam: this.ordertListQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            item.unValueUnreceiptLockAmount = subFloat(
              item.baseAmount,
              item.valueUnreceiptLockAmount
            );
            item.baseEntranceHomeAmount = item.unValueUnreceiptLockAmount;
            item.baseMaterialTotalprice = mulFloat(
              item.baseMaterialUnitprice,
              item.baseEntranceHomeAmount
            );
            item.baseMaterialTotalpriceUntaxed = mulFloat(
              item.baseMaterialUnitpriceUntaxed,
              item.baseEntranceHomeAmount
            );
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
          });
          this.ordertList = res.data.data.dataList;
          this.ordertListQuery.total = res.data.data.totalCount;
          this.listLoading = false;
        }
        this.listLoading = false;
      });
    },
    selectAllCheckboxChange(val) {
      this.itemListPro = val.records;
    },
    selectChangeEvent(val) {
      this.itemListPro = val.records;
    },
    showClick() {
      this.itemList = this.itemListPro;
      var str = "";
      this.itemListPro.forEach((item, index) => {
        if (index === 0) {
          str += item.globalSearchNumber;
        } else {
          if (!str.includes(item.globalSearchNumber)) {
            str += "," + item.globalSearchNumber;
          }
        }
      });
      if (this.itemListPro.length > 0) {
        this.addData.baseWarehouseWareName = this.itemListPro[0].valueWarehousingWarehouse;
        this.addData.baseWarehouseWareId = this.itemListPro[0].baseWarehouseWareId;
        this.addData.globalSearchNumber = str;
      }
      this.dialogClose();
    },
    backHome() {
      this.$emit("backHome");
    },
    dialogClose() {
      this.dialogState = {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
      };
    },
  },
};
</script>
<style scoped>
.input {
  width: 100%;
}

.btnOne {
  background: #1476c3;
  color: white;
  margin-right: 20px;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
